module.exports = __webpack_public_path__ + "static/media/STANDARD_START.07e413a4.mp3";